export enum ColorGroup {
  Regular = 'regular',
  Project = 'project',
  Area = 'area',
}
